import LivelinkLogoSvg from "@/client/components/common/livelink-logo";
import { Field, FieldGroup } from "@/client/components/shad/field";
import { Separator } from "@/client/components/shad/separator";
import { useAppForm } from "../form-context";
import { defaultValues, signInFormOptions } from "./shared";
import { UserBlock } from "./blocks/UserBlock";
import { Button } from "@/client/components/shad/button";
import { IconChevronRight } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { useStore } from "@tanstack/react-form";

import { PinBlock } from "./blocks/PinBlock";
import { loginUser } from "@/client/hooks/useUserQuery";
import { toast } from "sonner";

export const SignInPage = () => {
  const [stage, setStage] = useState(1);
  const { mutateAsync, isError } = loginUser();

  const form = useAppForm({
    ...signInFormOptions,
    defaultValues: defaultValues,

    onSubmit: async ({ value }) => {
      console.log("Raw Value signin", value);

      try {
        await mutateAsync({ id: value.id, pin: value.pin });
      } catch (err) {
        console.log("Handled in UI:", err);
        toast.error("Incorrect PIN", {
          description: "Please enter the correct PIN for this account",
          position: "top-center",
        });
      }
    },
  });

  const id = useStore(form.store, (state) => state.values.id);

  useEffect(() => {
    if (isError) {
      form.setFieldValue("pin", "");
    }
  }, [isError]);

  return (
    <div className="-mt-32">
      <header className="flex justify-center">
        <LivelinkLogoSvg className="-ml-4" />
      </header>
      <Separator className="my-6" />
      <form
        id="signin-form"
        className="h-96"
        onSubmit={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        {stage === 1 && (
          <FieldGroup>
            <UserBlock form={form} />
            <Field className="justify-end" orientation="horizontal">
              <Button
                disabled={id === null}
                onClick={() => setStage(2)}
                variant="secondary"
                size="lg"
              >
                Sign in <IconChevronRight />
              </Button>
            </Field>
          </FieldGroup>
        )}

        {stage === 2 && (
          <FieldGroup className="animate fade-in-50">
            <PinBlock form={form} />
            {/*<Field className="justify-end" orientation="horizontal">
              <Button onClick={() => setStage(1)} variant="secondary" size="lg">
                <IconChevronLeft /> Back
              </Button>
            </Field>*/}
          </FieldGroup>
        )}
      </form>
    </div>
  );
};
